import React, { useEffect, useState } from "react";
import { allroles } from "../funtionsBD/Mainservice";
import { useTranslation } from "react-i18next";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate } from "react-router-dom";

export function RolesList() {
  const [data, setdata] = useState();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const usersStyle = {
    padding: "15px 20px",
  };
  
  // Get current user data to check if they're a super admin
  const currentUser = JSON.parse(localStorage.getItem("user"));
  const isSuperAdmin = currentUser?.isSuperAdmin;
  useEffect(() => {
    getrole();
  }, []);

  const getrole = async () => {
    try {
      const response = await allroles();
      setdata(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };
  console.log(data);

  return (
    <div style={usersStyle}>
      <div className="data_table_over">
        <table className="data_table">
          <thead>
            <tr>
              <th>{t("role")}</th>
              <th>{t("permission")}</th>
              <th>{t("action")}</th>
            </tr>
          </thead>
          <tbody>
            {data?.map((item, index) => (
              <tr key={item.id}>
                <td>{item.role_name}</td>

                <td>
                  <ul style={{ marginLeft: "10px" }}>
                    {item.permissions.map((i) => (
                      <li key={i.id}>{i.name}</li>
                    ))}
                  </ul>
                </td>
                <td>
                  {/* Only show edit button if:
                      1. Current user is a super admin (can edit all roles), OR
                      2. Current user is not a super admin but the role is not "Super Admin" */}
                  {isSuperAdmin || item.role_name !== "Super Admin" ? (
                    <EditIcon
                      sx={{ color: "var(--black)" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate("/Edit_role", {
                          state: {
                            info: item,
                          },
                        });
                      }}
                    />
                  ) : (
                    <span style={{ color: "var(--gray)", fontSize: "12px" }}>
                      Restricted
                    </span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
